import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();

  const businessUnitSchema = yup.object({
    id: yup.string().nullable().optional(),
    name: yup.string().required(t('errorMessages.required')),
    meta: yup.object({
      unit: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .typeError(t('errorMessages.invalidNumber'))
        .required(t('errorMessages.required')),
      jde_environment: yup.string().nullable(),
    }),
    market_place: yup.object({
      is: yup.object({
        enabled: yup.boolean().nullable(),
      }),
      label: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup.string().required(t('errorMessages.required')).nullable(),
            fr: yup.string().nullable(),
          }),
          otherwise: yup.object({
            en: yup.string().nullable().optional(),
            fr: yup.string().nullable().optional(),
          }),
        }),
      location_description: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup.string().required(t('errorMessages.required')),
            fr: yup.string().nullable(),
          }),
          otherwise: yup.object({
            en: yup.string().nullable().optional(),
            fr: yup.string().nullable().optional(),
          }),
        }),
      pickup_instruction: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup
              .string()
              .required(t('errorMessages.required'))
              .max(200, t('errorMessages.max', { count: 200 })),
            fr: yup
              .string()
              .nullable()
              .max(200, t('errorMessages.max', { count: 200 })),
          }),
          otherwise: yup.object({
            en: yup
              .string()
              .nullable()
              .optional()
              .max(200, t('errorMessages.max', { count: 200 })),
            fr: yup
              .string()
              .nullable()
              .optional()
              .max(200, t('errorMessages.max', { count: 200 })),
          }),
        }),
      logo: yup.string().nullable(),
    }),
  });

  return {
    businessUnitSchema,
  };
};
